<template>
  <div>
    <div class="loa" v-show="loadingAmin">
      <transition name="fade">
        <div class="loader" v-if="visible">
          <div class="inner one"></div>
          <div class="loading"></div>
          <el-progress
              :percentage="percentage"
              :color="customColor"
              text-color="#fff"
          ></el-progress>
          <p class="loader_text">系统正在加载中......</p>
          <p class="loader_textO">系统配置初始化......</p>
          <p class="loader_textT">模型加载中......</p>
        </div>
      </transition>
      <div class="nameBox">
        <!-- 系统名称 -->
        <p class="p1">智慧物联能效平台</p>
      </div>
    </div>
  </div>


</template>

<script>
export default {
  props: {
    m: {
      type: Array,
    },
    name,
  },
  data() {
    return {
      customColor: "#fff",
      timer: null,
      timers: null,
      percentage: 0,
      visible: null,
      loadingAmin: true,
    };
  },
  mounted() {
    this.visible = this.$store.state.loadingShow;
    this.loadingAmin = this.$store.state.loadingAmin;
    this.setTime(0);
    this.show();
  },
  beforeDestroy() {
    window.clearInterval(this.timers);
    this.timers = null;
  },
  methods: {
    setTime(i) {
      let that = this;
      setTimeout(() => {
        //1秒执行一次 总数为100 改成2就50秒 改成3就33.3秒
        if (that.percentage < 100) {
          that.percentage = that.m[i];
          that.setTime(i+1);
        } else {
          that.percentage = 100;
          //关闭弹窗
          this.$store.commit("ChangeLoadingShow", false);
          this.visible = this.$store.state.loadingShow;
          setTimeout(() => {
            this.$store.commit("ChangeLoadingAmin", false);
            this.loadingAmin = this.$store.state.loadingAmin;
          }, 500);
        }
      }, 1000);
    },

    show() {
      var _this = this;
      let arr = [1, 2, 3, 1];
      // setTimeout("changeBody(id)",2000);
      for (let i = 0; i < arr.length; i++) {
        (function (j) {
          setTimeout(() => {
            _this.changeBody(arr[j]);
          }, 2000 * j);
        })(i);
      }
    },
    changeBody(index) {
      if (!this.$store.state.loadingShow) {
        return;
      }
      switch (index) {
        case 1: {
          document.querySelector(".loader_text").style.display = "block";
          document.querySelector(".loader_textO").style.display = "none";
          document.querySelector(".loader_textT").style.display = "none";
          break;
        }
        case 2: {
          document.querySelector(".loader_text").style.display = "none";
          document.querySelector(".loader_textO").style.display = "block";
          document.querySelector(".loader_textT").style.display = "none";
          break;
        }
        case 3: {
          document.querySelector(".loader_text").style.display = "none";
          document.querySelector(".loader_textO").style.display = "none";
          document.querySelector(".loader_textT").style.display = "block";
          break;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.loa {
  z-index: 999;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: linear-gradient(-36deg, #020011 14%, #001626 100%);

  .el-progress {
    position: absolute;
    top: 48%;
    left: 50%;
    margin-left: -345px;
    height: 16px;
    margin-top: 120px;
  }

  ::v-deep .el-progress-bar {
    width: 740px;
    margin-right: -50px !important;
  }

  ::v-deep .el-progress__text {
    position: absolute;
  }

  ::v-deep .el-progress-bar__outer {
    width: 100%;
    background: #000;
    border: 1px solid #ffffff;
    height: 8px !important;
    border-radius: 0 !important;
    position: initial;
  }

  ::v-deep .el-progress-bar__inner {
    height: 8px !important;
    border-radius: 0 !important;
    box-shadow: 0 0 5px 2px rgba(255, 255, 255, 0.4) !important;
    top: 4px;
  }


}
.nameBox {
  position: fixed;
  top: 48px;
  left: 60px;
  z-index: 9999;

  p {
    color: #fff;
    font-family: "PingFang SC";
    font-weight: bold;
  }

  .p1 {
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
  }

  .p2 {
    padding-top: 15px;
    font-weight: 500;
    font-size: 22px;
    color: #ffffff;
    letter-spacing: 0;
  }
}
.loader {
  z-index: 9999;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  perspective: 800px;

  p {
    font-size: 14px;
    font-family: "Segoe Script";
    text-align: left;
    padding-top: 5px;
  }
}

.inner {
  position: absolute;
  box-sizing: border-box;
  left: 50%;
  top: 46%;
  margin-top: -300px;
  margin-left: -200px;
  width: 400px;
  height: 400px;
}

.inner.one {
  background-image: url("../assets/images/circle.png");
  background-size: 100% 100%;
  -webkit-animation: rotation 3s linear infinite;
  animation: rotation 3s linear infinite;
}

.loading {
  position: absolute;
  width: 150px;
  top: 46%;
  left: 50%;
  height: 30px;
  margin-left: -75px;
  margin-top: -115px;
  background-image: url("../assets/images/loading.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -webkit-animation: rotate 3s linear infinite;
  animation: rotate 3s linear infinite;
}

.el-progress-bar__outer {
  background-color: #000;
  opacity: 1;
  border: 1px solid #999;
}

.loader_text {
  width: 690px;
  position: absolute;
  top: 48%;
  left: 50%;
  font-size: 28px;
  color: #fff;
  text-align: center;
  display: block;
  margin-left: -345px;
  margin-top: 140px;
  font-weight: 500;
  font-family: "MyFont" !important;
  /* color:red; */
}

.loader_textT {
  width: 690px;
  display: none;
  position: absolute;
  top: 48%;
  left: 50%;
  font-size: 28px;
  color: #fff;
  text-align: center;
  margin-left: -345px;
  margin-top: 140px;
  font-weight: 500;
  font-family: "MyFont" !important;
  /* color:red; */
}

.loader_textO {
  width: 690px;
  display: none;
  position: absolute;
  top: 48%;
  left: 50%;
  margin-left: -345px;
  font-size: 28px;
  color: #fff;
  text-align: center;
  margin-top: 140px;
  font-weight: 500;
  font-family: "MyFont" !important;
  /* color:red; */
}

@keyframes rotation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}

@keyframes rotate {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.5;
  }
  40% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
  60% {
    opacity: 0.8;
  }
  75% {
    opacity: 0.5;
  }
  90% {
    opacity: 0.2;
  }
  100% {
    opacity: 0;
  }
}

/* @keyframes rotate-one {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
}

@keyframes rotate-two {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
}

@keyframes rotate-three {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
} */
/* .loader_text {
  font-size: 25px;
  color: #0060ca;
  text-align: center;
  padding-top: 190px;
} */
.fades-leave-active {
  transition: opacity 2s;
}

.fades-enter,
.fades-leave-active {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
